<template>
	<div class="animated fadeIn">
		<!-- Component -->
		<div class="row">
			<div class="col-12">
				<OverviewCard
					name="Datasources"
					link="/datasources/0"
					:keywords="keywords"
					:search="search"
					@keywordsChange="setKeywords"
				>
					<table class="table table-bordered table-striped table-sm mb-0">
						<thead>
							<tr>
								<th>{{ $t('connection name') }}</th>
								<th>{{ $t('Database Driver') }}</th>
								<th>{{ $t('db_or_service_name') }}</th>
								<th>{{ $t('status') }}</th>
								<th>{{ $t('action') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(record, i) in records">
								<td>{{ record.entity.name }}</td>
								<td v-text="get_driver(record.entity.driver)"></td>
								<td>{{ record.entity.dbname }}</td>
								<td class="text-center">
									<c-switch
										class="m-0"
										@change="set_status(record)"
										type="icon"
										size="sm"
										variant="success"
										v-bind="{on: '\uf00c', off: '\uf00d'}"
										:pill="true"
										:checked="!!!record.deleted_at"
									/>
								</td>
								<td class="text-center">
									<router-link class="mr-2" :to="'/datasources/' + record.data_source_id">
										<i class="fa fa-edit fa-lg" style="line-height: 1;"></i>
									</router-link>
									<button class="btn btn-link p-0 m-0" @click="delete_it(i, true)">
										<i class="fa fa-remove fa-lg"></i>
									</button>
								</td>
							</tr>
							<tr v-if="!records.length" v-cloak>
								<td colspan="5">
									<div class="text-center">{{ $t('no data') }}!</div>
								</td>
							</tr>
						</tbody>
					</table>
					<pagination :dataSet="dataSet" @updated="paginate_to"></pagination>
				</OverviewCard>
			</div>
			<!-- /.col -->
		</div>
		<!-- /.row -->
		<b-modal
			title="Modal title"
			class="modal-primary"
			v-model="deleteModal"
			@ok="delete_it(active_element_index, false)"
		>
			{{ $t('Do you really need to delete') }}
			<code>
				<strong>{{ active_element_name }}</strong>
			</code>
		</b-modal>
	</div>
</template>

<script>
import {cSwitch, OverviewCard} from '../../components'
import searchMixins from '../../mixins/search'
import axios from 'axios'

export default {
	name: 'datasetList',
	components: {
		cSwitch,
		OverviewCard,
	},
	mixins: [searchMixins],
	data() {
		return {
			records: [],
			dataSet: false,
			deleteModal: false,
			active_element_index: 0,
			active_element_name: '',
			clone_public_ds_id: 0,
			clone_private_ds_id: 0,
			public_datasets: [],
			private_datasets: [],
		}
	},
	methods: {
		get_driver(key) {
			for (var i = this.$store.state.sql_support_drivers.length - 1; i >= 0; i--) {
				if (this.$store.state.sql_support_drivers[i].value == key) {
					return this.$store.state.sql_support_drivers[i].label
				}
			}
			return key
		},
		paginate_to(page) {
            this.records = []
            this.dataSet = false
			this.$root.loader = true
			axios
				.get(`/data_sources?${this.keywords.length ? 'search=' + this.keywords + '&' : ''}page=${page}`)
				.then((response) => {
					this.$root.loader = false
					if (response.data.status == 1) {
						this.dataSet = response.data.data
						this.records = response.data.data.data
					} else {
						this.$root.loader = false
					}
				})
		},
		set_status({data_source_id}) {
			if (data_source_id) {
				axios.patch('/data_sources/change_status/' + data_source_id, {})
			}
		},

		delete_it(i, alarm) {
			var element = this.records[i]
			if (alarm) {
				this.deleteModal = true
				this.active_element_index = i
				this.active_element_name = element.entity.name
			} else {
				if (element) {
					this.$root.loader = true
					axios
						.delete('/data_sources/' + element.data_source_id, {})
						.then((response) => {
							if (response.data.status == 1) {
								this.deleteModal = false
								this.records.splice(i, 1)
								this.$root.loader = false
								if (!this.records.length) {
									this.paginate_to(this.page)
								}
							}
						})
				}
			}
		},
	},
	mounted() {
		var params = getUrlParams()
		params && params.page && Number.isInteger(parseInt(params.page)) ? params.page : 1
		this.paginate_to(params && params.page && Number.isInteger(parseInt(params.page)) ? params.page : 1)
	},
}
</script>
